module.exports = __webpack_public_path__ + "img/work.0e48efde.svg";